export default function MapSection() {
  return (
    <div id="map" className="flex flex-col gap-5">
      {/* Map Embed */}
      <div className="rounded-2xl overflow-hidden border border-[#f0ebe4] h-72 md:h-96">
        <iframe
          title="Koorpet 公司地址"
          src="https://maps.google.com/maps?q=FLAT%20%2FRM%20A%209%2FF%20SILVERCORP%20INTERNATIONAL%20TOWER%20707-713%20NATHAN%20ROAD%20MONGKOK%20HONGKONG&t=&z=15&ie=UTF8&iwloc=&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      {/* Address Card */}
      <div className="bg-white rounded-2xl border border-[#f0ebe4] p-6">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#C8714A]/10 flex-shrink-0">
            <i className="ri-map-pin-2-line text-[#C8714A] text-lg"></i>
          </div>
          <div className="flex-1">
            <div className="text-sm text-[#666] leading-relaxed mb-3">
              FLAT /RM A 9/F SILVERCORP INTERNATIONAL TOWER<br />
              707-713 NATHAN ROAD MONGKOK HONGKONG
            </div>
            <div className="flex flex-wrap gap-4 text-xs text-[#999]">
              <div className="flex items-center gap-1.5">
                <i className="ri-car-line text-[#C8714A]"></i>
                导航至弥敦道Silvercorp Tower即达
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-parking-box-line text-[#C8714A]"></i>
                大厦内提供访客停车位
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Business Hours */}
      <div className="bg-white rounded-2xl border border-[#f0ebe4] p-6">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#C8714A]/10 flex-shrink-0">
            <i className="ri-time-line text-[#C8714A] text-lg"></i>
          </div>
          <div className="text-sm font-bold text-[#1a1a1a]">营业时间</div>
        </div>
        <div className="flex flex-col gap-2.5">
          {[
            { day: '周一 - 周五', time: '09:00 - 18:00', active: true },
            { day: '周六', time: '10:00 - 16:00', active: false },
            { day: '周日 & 法定节假日', time: '休息', active: false },
          ].map((row) => (
            <div key={row.day} className="flex items-center justify-between py-2 border-b border-[#f5f0eb] last:border-0">
              <span className="text-sm text-[#555]">{row.day}</span>
              <span className={`text-sm font-medium ${row.active ? 'text-[#C8714A]' : 'text-[#aaa]'}`}>
                {row.time}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
